module.exports = __webpack_public_path__ + "static/img/JF.6b07d9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/JF.png
// module id = w0LK
// module chunks = 34